import createIcon from '../../createIcon';

/**
 * @component @name Vrpano
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNjkgNC4wNDc4N0MxOC42NiA0LjcyNzg3IDE1Ljg2IDUuNDk3ODcgMTIgNS40OTc4N0M4LjExIDUuNDk3ODcgNS4wNSA0LjY1Nzg3IDMuMzEgNC4wNjc4N0MyLjY3IDMuODQ3ODcgMiA0LjMyNzg3IDIgNS4wMTc4N1YxOC45OTc5QzIgMTkuNjc3OSAyLjY2IDIwLjE2NzkgMy4zMSAxOS45NDc5QzUuMzYgMTkuMjU3OSA4LjEgMTguNDk3OSAxMiAxOC40OTc5QzE1Ljg3IDE4LjQ5NzkgMTguNjYgMTkuMjU3OSAyMC42OSAxOS45NDc5QzIxLjM0IDIwLjE1NzkgMjIgMTkuNjc3OSAyMiAxOC45OTc5VjQuOTk3ODdDMjIgNC4zMTc4NyAyMS4zNCAzLjgzNzg3IDIwLjY5IDQuMDQ3ODdaTTEyIDE0Ljk5NzlDOS42NiAxNC45OTc5IDcuNDggMTUuMTQ3OSA1LjQ4IDE1LjQwNzlMOS4xNyAxMC45ODc5TDExLjE3IDEzLjM4NzlMMTQgOS45OTc4N0wxOC41MSAxNS4zOTc5QzE2LjUyIDE1LjE0NzkgMTQuMyAxNC45OTc5IDEyIDE0Ljk5NzlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Vrpano = createIcon('Vrpano', [
  [
    'path',
    {
      d: 'M20.69 4.04787C18.66 4.72787 15.86 5.49787 12 5.49787C8.11 5.49787 5.05 4.65787 3.31 4.06787C2.67 3.84787 2 4.32787 2 5.01787V18.9979C2 19.6779 2.66 20.1679 3.31 19.9479C5.36 19.2579 8.1 18.4979 12 18.4979C15.87 18.4979 18.66 19.2579 20.69 19.9479C21.34 20.1579 22 19.6779 22 18.9979V4.99787C22 4.31787 21.34 3.83787 20.69 4.04787ZM12 14.9979C9.66 14.9979 7.48 15.1479 5.48 15.4079L9.17 10.9879L11.17 13.3879L14 9.99787L18.51 15.3979C16.52 15.1479 14.3 14.9979 12 14.9979Z',
      key: '3swkbj',
    },
  ],
]);

export default Vrpano;
